import React, { useState } from "react";
import SubleagueTableContainer from "./Containers/SubleagueTableContainer";
import SubleagueChatContainer from "../SubleagueChat/SubleagueChatContainer";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from 'prop-types'


const SubleaguePanel = ({subleague, open, classification, showMoreButton, intl}) => {

    const [displayRanked, setDisplayRanked] = useState(true);

    const toggleRankedTeams = () => {
        setDisplayRanked(prevState => !prevState);
    }

    if (!open) {
        return null;
    }

    return <div>
        <section id="sub-league-panel" className={"ranking-table module" + (showMoreButton ? "  sub-league-ranking" : "")}>
            <header style={{ position: "relative" }} className="module__header">
                <h2 className="ranking-table__title module__title">{subleague.name}</h2>
                {showMoreButton ? <button onClick={toggleRankedTeams} style={{ position: "absolute", right: "4px", top: "7.5px", fontSize: "12px", minHeight: "25px", lineHeight: "25px" }}  className="btn-orange">
                    { displayRanked ? intl.formatMessage({ id: "ranking.subleagues.allTeams" }) : intl.formatMessage({ id: "ranking.subleagues.rankedTeams" }) }
                </button> : ""}
            </header>

            <SubleagueTableContainer displayRanked={displayRanked} classificationId={classification.id}/>
            {renderTableLegend(subleague)}
        </section>
        <SubleagueChatContainer subleagueId={subleague.id}/>
    </div>
};


SubleaguePanel.propTypes = {
    subleague: PropTypes.shape({
        id: PropTypes.any.isRequired,
        name: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }).isRequired,
    classification: PropTypes.shape({
        id: PropTypes.any.isRequired,
    }).isRequired,
    open: PropTypes.bool
};

const renderTableLegend = function (subleague) {
    if (subleague.type === 'prize-subleague-entry') {
        return (<>
        <div className="ranking-table__note">
            <span className="ranking-entry__star"><span className="glyphicon glyphicon-star"/></span>
            <FormattedMessage id="subleagues.starNote"/>
            <p style={{ margin: "10px 0 0 0" }}>
                <FormattedMessage id="subleagues.rankedNote"/>
            </p>
        </div>
        </>)
    }

    return null;
};

export default injectIntl(SubleaguePanel)